import { Anchor, Card, Grid, Heading } from '@design-systems/canvas-ui'
import DashboardConfig from '../config/ReportingDashboardConfig'
import { ReactRouterCanvasAnchor, PageLayout } from '@plm-core/utils'
import type { DashboardItem } from '../config/ReportingDashboardConfig'
import styles from './Reporting.module.css'

function InsightsDashboard({ isInternal }: { isInternal: boolean }) {
  return (
    <PageLayout>
      <Grid.Container>
        {(DashboardConfig as DashboardItem[]).map(
          ({
            title,
            anchorText,
            route,
            show,
            description,
            showExternal,
            isExternal,
          }: DashboardItem) =>
            show &&
            (isInternal || showExternal) && (
              <Grid.Item ls={4} size={{ xs: 4 }}>
                <Card className={`${styles.dashboardCard} hc8-pa-3x`}>
                  <Heading className="hc8-mt-none hc8-mb-none">{title}</Heading>
                  <p className={`hc8-fs-100 ${styles.dashboardDescription}`}>
                    {description}
                  </p>
                  {isExternal ? (
                    <Anchor href={route({ isInternal })}>{anchorText}</Anchor>
                  ) : (
                    <ReactRouterCanvasAnchor to={route({ isInternal })}>
                      {anchorText}
                    </ReactRouterCanvasAnchor>
                  )}
                </Card>
              </Grid.Item>
            ),
        )}
      </Grid.Container>
    </PageLayout>
  )
}

export default InsightsDashboard
